import {Component, OnInit} from '@angular/core';
import {MonitoringService} from './shared/services/monitoring.service';
import {UserProfileService} from './auth/services/user-profile.service';
import {CampaignClient} from './shared/apis/api.client';
import {CampaignService} from './shared/services/campaign.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    title = 'neediestcases-dashboard';

    constructor(private readonly monitoringService: MonitoringService, private readonly userProfileService: UserProfileService,
                private campaignClient: CampaignClient, private campaignService: CampaignService) {
    }

    ngOnInit(): void {
        this.campaignClient.getCurrentCampaign().subscribe(result => this.campaignService.setCurrentCampaign(result.campaign));
        this.userProfileService.init();
        this.monitoringService.setUpRouteLogging();
    }

}
